import { Role } from "./Role";

const RoleHierarchy = {
  [Role.SUPER_ADMIN]: new Set<Role>([Role.SUPER_ADMIN]),
  [Role.ADMIN]: new Set<Role>([Role.ADMIN, Role.USER]),
  [Role.USER]: new Set<Role>([Role.USER]),
};

export default RoleHierarchy;
